module.exports = __webpack_public_path__ + "img/opportunity.13474aa7.png";